export type BuildStage =
  | 'PLANNING'
  | 'SLAB'
  | 'FRAME'
  | 'ROOF'
  | 'ROUGH_INS'
  | 'FIXING'
  | 'PRACTICAL_COMPLETION';

export type TaskStatus =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'AWAITING_CLIENT'
  | 'COMPLETE'
  | 'SKIPPED';

export type DocumentStatus = 'REQUESTED' | 'UPLOADED' | 'APPROVED' | 'REJECTED';

export interface PortalTask {
  id: string;
  title: string;
  status: TaskStatus;
  dueDate?: string;
  assignedToName?: string;
}

export interface PortalDocument {
  id: string;
  title: string;
  description?: string;
  status: DocumentStatus;
  dueDate?: string;
  fileUrl?: string;
  rejectionReason?: string;
  isSMSFOnly?: boolean;
}

export interface PortalCall {
  id: string;
  title: string;
  callType: string;
  scheduledAt: string;
  durationMinutes: number;
  meetingUrl?: string;
  hostName: string;
  hostRole: string;
}

export interface BuildPhoto {
  id: string;
  stage: BuildStage;
  caption: string;
  fileUrl: string;
  thumbnailUrl: string;
  takenAt: string;
}

export interface TeamMember {
  name: string;
  role: string;
  email?: string;
  phone?: string;
  bookingUrl?: string;
}

export interface PortalDeal {
  id: string;
  isSMSF: boolean;
  activePhase: number;
  buildStage?: BuildStage;
  propertyAddress?: string;
  assignedStrategist: TeamMember;
  assignedBroker: TeamMember;
  assignedProjectCoordinator?: TeamMember;
  arrowwhiteContact?: TeamMember;
}

export const BUILD_STAGE_LABELS: Record<BuildStage, string> = {
  PLANNING: 'Planning',
  SLAB: 'Slab',
  FRAME: 'Frame',
  ROOF: 'Roof',
  ROUGH_INS: 'Rough-Ins',
  FIXING: 'Fixing',
  PRACTICAL_COMPLETION: 'Practical Completion',
};

export const BUILD_STAGE_ORDER: BuildStage[] = [
  'PLANNING',
  'SLAB',
  'FRAME',
  'ROOF',
  'ROUGH_INS',
  'FIXING',
  'PRACTICAL_COMPLETION',
];
